/**
 * 결과 그리드 셀 표시 포맷 (Phase 2)
 *
 * 원칙: **표시만 바꾸고 원본은 보존한다.**
 * - 복사/CSV 내보내기/툴팁에는 원본 문자열을 쓴다.
 * - 숫자에 천단위 구분을 넣으면 다시 숫자로 파싱하기 어려워지므로 표시 전용이다.
 */

const ISO_LIKE = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}:\d{2}/;
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

function pad(n) { return String(n).padStart(2, '0'); }

function toDate(value) {
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string' && (ISO_LIKE.test(value) || DATE_ONLY.test(value))) {
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
}

function formatDate(d, mode) {
  const ymd = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  if (mode === 'date') return ymd;
  if (mode === 'locale') return d.toLocaleString();   // 인자 없음 = 브라우저 로캘 (설정 라벨과 일치)
  // 'iso' (기본)
  return `${ymd} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/**
 * 셀 값 → 표시 문자열.
 * @returns {{ text: string, isNull: boolean, raw: string }}
 *   raw 는 툴팁/복사용 원본 문자열.
 */
export function formatCellValue(value, opts = {}) {
  const {
    nullText = '[NULL]',
    dateFormat = 'iso',
    numberGrouping = true,
  } = opts;

  if (value === null || value === undefined) {
    return { text: nullText, isNull: true, raw: '' };
  }

  const raw = String(value);

  // 날짜 — 'raw' 모드면 손대지 않는다
  if (dateFormat !== 'raw') {
    const d = toDate(value);
    if (d) return { text: formatDate(d, dateFormat), isNull: false, raw };
  }

  // 숫자 — DB 드라이버가 number 로 준 값만 대상 (전화번호 등 문자열은 제외)
  if (typeof value === 'number' && Number.isFinite(value)) {
    if (numberGrouping) {
      return { text: value.toLocaleString('en-US', { maximumFractionDigits: 20 }), isNull: false, raw };
    }
    return { text: raw, isNull: false, raw };
  }

  return { text: raw, isNull: false, raw };
}
